<template>
  <div id="app">
<!--<element-view></element-view>-->
<router-view/>
  </div>
</template>
<script>
/*import ElementView from './views/element/ElementView.vue'*/
export default{
  components: { /*ElementView*/ },
  data:function(){
    return{
      message:"hello vue"
    }
  },
  methods:{

  }
}
</script>

<style>

</style>
